import { render, staticRenderFns } from "./CoolLightBox.vue?vue&type=template&id=40da69f0&"
import script from "./CoolLightBox.vue?vue&type=script&lang=js&"
export * from "./CoolLightBox.vue?vue&type=script&lang=js&"
import style0 from "./CoolLightBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports